import { Component, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LazyMotion, MotionConfig } from "framer-motion";
import { PerformanceProvider } from "./lib/performance";
import Layout from "./components/Layout";
import Home from "./pages/Home";

const About = lazy(() => import("./pages/About"));
const Products = lazy(() => import("./pages/Products"));
const ProductDetail = lazy(() => import("./pages/ProductDetail"));
const ExportProcess = lazy(() => import("./pages/ExportProcess"));
const PackagingShipping = lazy(() => import("./pages/PackagingShipping"));
const Certifications = lazy(() => import("./pages/Certifications"));
const FAQ = lazy(() => import("./pages/FAQ"));
const RequestQuote = lazy(() => import("./pages/RequestQuote"));
const Contact = lazy(() => import("./pages/Contact"));
const Track = lazy(() => import("./pages/Track"));
const NotFound = lazy(() => import("./pages/NotFound"));
const loadMotion = () => import("./lib/motion-features").then((module) => module.default);

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div data-testid="page-load-error" role="alert" className="min-h-screen flex flex-col items-center justify-center bg-[#FAF7F0] text-center px-6">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-tang">Something broke</p>
          <h1 className="font-serif text-3xl font-bold text-forest mt-4">Please refresh the page</h1>
          <p className="text-sage mt-2 text-sm">{String(this.state.error?.message || this.state.error)}</p>
          <button data-testid="page-reload-button" onClick={() => window.location.reload()} className="mt-6 bg-forest text-cream px-6 py-3">Try again</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <PerformanceProvider>
      <MotionConfig reducedMotion="user">
      <LazyMotion features={loadMotion} strict>
      <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/export-process" element={<ExportProcess />} />
              <Route path="/packaging-shipping" element={<PackagingShipping />} />
              <Route path="/certifications" element={<Certifications />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/request-quote" element={<RequestQuote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/track" element={<Track />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
      </BrowserRouter>
      </LazyMotion>
      </MotionConfig>
      </PerformanceProvider>
    </ErrorBoundary>
  );
}
